import hubGoIcon from '../../assets/branding/hubgo-icon.svg';
import hubGoIconDark from '../../assets/branding/hubgo-icon-dark.svg';
import hubGoLogo from '../../assets/branding/hubgo-logo.svg';
import hubGoLogoDark from '../../assets/branding/hubgo-logo-dark.svg';
import dispatchGoIcon from '../../assets/branding/dispatchgo-icon.svg';
import dispatchGoIconDark from '../../assets/branding/dispatchgo-icon-dark.svg';
import dispatchGoLogo from '../../assets/branding/dispatchgo-logo.svg';
import dispatchGoLogoDark from '../../assets/branding/dispatchgo-logo-dark.svg';

/** Transparent vectors from ots-site/public/logos, matching the CDN wordmarks.
 * Dark variants lighten the lettering and center marks while preserving the red corners.
 */
export const otsAppLogos = {
  'hub-go': {
    label: 'HubGo',
    iconSrc: hubGoIcon,
    darkIconSrc: hubGoIconDark,
    logoSrc: hubGoLogo,
    darkLogoSrc: hubGoLogoDark,
    logoAspectRatio: 866 / 263,
  },
  'dispatch-go': {
    label: 'DispatchGo',
    iconSrc: dispatchGoIcon,
    darkIconSrc: dispatchGoIconDark,
    logoSrc: dispatchGoLogo,
    darkLogoSrc: dispatchGoLogoDark,
    logoAspectRatio: 1346 / 263,
  },
} as const;
